import React from "react";

function PodcastIntroStep1() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 37.042 25.135"
      xmlSpace="preserve"
    >
      <defs>
        <path d="M92.268 751.949H578.798V800.16H92.268z"></path>
      </defs>
      <g>
        <path
          fill="#4d4d4d"
          fillOpacity="1"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="9.333"
          strokeWidth="0.038"
          d="M30.229 11.17c-.143-.027-.255-.16-.297-.354a1.155 1.155 0 01.003-.363.507.507 0 01.176-.29.355.355 0 01.346-.024c.123.058.209.193.237.37.014.09.009.246-.01.326-.061.241-.244.376-.455.336zm-4.685 1.528a.584.584 0 01-.503-.434l-.015-.053-.002-1.715c-.001-1.208 0-1.73.006-1.77a.583.583 0 01.43-.493l.057-.015h9.767l.059.018a.59.59 0 01.41.423l.015.056.002 1.684c.001 1.155 0 1.709-.005 1.764a.558.558 0 01-.169.366.57.57 0 01-.35.169c-.075.008-9.63.008-9.702 0zm1.769-1.311c.24-.018.407-.085.525-.211.161-.173.196-.45.078-.633a.549.549 0 00-.246-.203 6.128 6.128 0 00-.348-.101 8.52 8.52 0 01-.335-.095c-.108-.042-.17-.09-.197-.15-.014-.03-.016-.046-.016-.106 0-.065.001-.074.021-.116a.36.36 0 01.235-.183.808.808 0 01.365.004c.17.047.282.18.283.337v.032h.244l-.005-.06c-.022-.292-.218-.487-.538-.535a1.456 1.456 0 00-.333 0c-.276.042-.457.188-.512.412a.714.714 0 00-.004.272c.037.147.15.26.314.313.024.008.164.046.311.085.147.039.291.08.321.09.163.06.248.148.254.264a.302.302 0 01-.084.235.306.306 0 01-.154.093.747.747 0 01-.288.032.668.668 0 01-.24-.04.403.403 0 01-.262-.347l-.009-.068h-.234l.004.07a.695.695 0 00.11.338c.107.156.303.25.563.27l.078.007c.006 0 .05-.002.099-.006zm1.528-.01a.494.494 0 00.301-.197l.028-.036v.183h.209l-.002-.698-.002-.697-.112-.002-.113-.002v.425c0 .444-.002.492-.03.574a.415.415 0 01-.16.214.37.37 0 01-.325.021.25.25 0 01-.118-.117l-.022-.044-.004-.535-.003-.534-.113-.002-.112-.002v.563c0 .62 0 .618.042.696a.398.398 0 00.143.144.615.615 0 00.393.046zm1.64-.004c.24-.055.407-.272.45-.585.012-.08.01-.258-.002-.339-.046-.298-.209-.494-.45-.544a.744.744 0 00-.27.003.488.488 0 00-.267.17l-.026.033v-.727h-.228v1.943h.208v-.165l.015.02c.027.039.11.115.154.14a.58.58 0 00.416.05zm3.924.006l.055-.007v-.194l-.018.005a.551.551 0 01-.087.006c-.078 0-.1-.01-.114-.051a6.016 6.016 0 01-.009-.522v-.5h.229v-.188h-.229l-.002-.19-.002-.19h-.221l-.002.19-.002.19-.093.002-.092.002-.002.092-.002.093h.189v.536c0 .462.001.542.01.576a.176.176 0 00.074.11c.073.051.154.061.318.04zm-3.002-.525l.002-.472.018-.051a.34.34 0 01.255-.235c.106-.019.205.018.257.096.046.07.045.051.045.621v.514h.235v-.47c0-.517 0-.508.042-.589a.389.389 0 01.144-.143c.14-.071.306-.024.362.101.028.064.03.113.03.62v.48h.23l-.003-.566c-.002-.518-.003-.57-.014-.606a.335.335 0 00-.259-.247.734.734 0 00-.263-.003.535.535 0 00-.272.168l-.025.03-.027-.04a.396.396 0 00-.23-.157.673.673 0 00-.255.003.5.5 0 00-.26.177l-.026.032-.002-.093-.002-.092h-.208l-.002.697-.002.698h.228zm2.175-.225l-.001-.697-.113-.002-.113-.002v1.398h.229zm.002-1.1v-.145h-.229v.289h.229z"
        ></path>
        <path
          fill="#556cd6"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="9.333"
          strokeWidth="0.159"
          d="M22.084 70.19c-2.83-.26-5.428-1.362-7.609-3.225a17.998 17.998 0 01-1.474-1.47 14.7 14.7 0 01-2.56-4.231c-1.235-3.092-1.415-6.616-.504-9.84 1.013-3.585 3.243-6.579 6.318-8.482.48-.297 1.549-.836 2.046-1.03 2.363-.928 4.826-1.174 7.272-.726 1.966.36 3.931 1.22 5.563 2.434a14.902 14.902 0 012.916 2.915c2.294 3.087 3.323 6.982 2.869 10.861-.497 4.245-2.719 8.041-6.092 10.408-.77.541-1.913 1.161-2.747 1.49-1.263.499-2.601.808-3.937.91-.5.038-1.573.03-2.06-.015zm4.52-6.255l-.008-.327-.378-.078c-1.174-.241-1.45-.487-1.54-1.372-.02-.188-.03-2.784-.03-7.75v-7.465h-.213c-.241 0-.188-.025-1.454.666-.324.177-.942.505-1.373.728l-1.177.611-.393.203-.008.262-.008.262h.71c.782 0 .892.019 1.089.18.132.11.26.36.323.633.05.214.052.463.052 5.423 0 5.497-.001 5.572-.13 6.246-.064.336-.13.528-.245.71-.064.1-.12.146-.262.213-.229.108-.691.254-1.296.408l-.477.12-.008.328-.008.327h6.842z"
          transform="scale(.26458)"
        ></path>
        <path
          fill="#fff"
          fillOpacity="1"
          stroke="gray"
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="9.333"
          strokeOpacity="1"
          strokeWidth="0.174"
          d="M19.713 2.604l15.657.001c.201-.014.347.123.358.298v1.452l.005 1.983c-.002.145-.164.308-.302.3 0 0 .271-.008-16.504-.008H1.257c-.141 0-.253-.075-.255-.255V2.901c-.003-.225.124-.29.29-.29l.932-.007"
        ></path>
        <text
          xmlSpace="preserve"
          style={{ lineHeight: "1.25", InkscapeFontSpecification: "FreeSans" }}
          x="119.367"
          y="67.621"
          fill="#000"
          fillOpacity="1"
          stroke="none"
          strokeWidth="0.265"
          fontFamily="FreeSans"
          fontSize="10.583"
          fontStretch="normal"
          fontStyle="normal"
          fontVariant="normal"
          fontWeight="normal"
          letterSpacing="0"
          wordSpacing="0"
        ></text>
        <path
          fill="#fdfdff"
          fillOpacity="1"
          stroke="#000"
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeOpacity="1"
          strokeWidth="0.259"
          d="M30.652 11.008l3.307 2.125-1.2.442 1.203 1.732-.984.58-1.205-1.756-.963.734z"
        ></path>
        <text
          xmlSpace="preserve"
          style={{ lineHeight: "1.25" }}
          x="2.118"
          y="5.155"
          fill="#000"
          fillOpacity="1"
          stroke="none"
          strokeWidth="0.048"
          fontFamily="Standard Greek"
          fontSize="1.934"
          fontStretch="normal"
          fontStyle="normal"
          fontVariant="normal"
          fontWeight="normal"
          letterSpacing="0"
          wordSpacing="0"
        >
          <tspan
            style={{ InkscapeFontSpecification: "Helvetica" }}
            x="2.118"
            y="5.155"
            strokeWidth="0.048"
            fontFamily="Helvetica"
            fontStretch="normal"
            fontStyle="normal"
            fontVariant="normal"
            fontWeight="normal"
          >
            https://mypodcast.com/rss
          </tspan>
        </text>
        <g
          ariaLabel="Podcast RSS Feed"
          style={{ lineHeight: "1.25" }}
          fill="gray"
          fillOpacity="1"
          strokeDasharray="none"
          strokeMiterlimit="4"
          strokeWidth="0.115"
          fontSize="1.832"
        >
          <path d="M3.097 1.995v.502h.227q.126 0 .195-.065.069-.066.069-.186t-.069-.185q-.069-.066-.195-.066zm-.181-.148h.408q.225 0 .34.102.115.1.115.297 0 .197-.116.299-.114.1-.339.1h-.227v.537h-.181z"></path>
          <path d="M4.337 2.296q-.133 0-.21.104-.076.102-.076.282t.076.284q.076.103.21.103.131 0 .208-.104.077-.104.077-.283 0-.178-.077-.282-.077-.104-.208-.104zm0-.14q.215 0 .337.14.123.14.123.386t-.123.387q-.122.14-.337.14-.216 0-.338-.14-.122-.14-.122-.387t.122-.386q.122-.14.338-.14z"></path>
          <path d="M5.729 2.332V1.79h.165v1.392h-.165v-.15q-.052.09-.132.133-.078.043-.19.043-.18 0-.295-.145-.114-.144-.114-.38 0-.237.114-.382.114-.145.296-.145.11 0 .19.044.08.043.131.132zm-.561.35q0 .182.074.286.075.103.206.103.13 0 .206-.103.075-.104.075-.286 0-.181-.075-.284-.075-.104-.206-.104-.13 0-.206.104-.074.103-.074.284z"></path>
          <path d="M6.954 2.219v.154q-.07-.039-.14-.058-.07-.02-.142-.02-.16 0-.249.103-.088.1-.088.284 0 .184.088.286.089.1.249.1.072 0 .141-.018.071-.02.14-.058v.152q-.068.032-.142.048-.074.016-.157.016-.226 0-.36-.142-.133-.142-.133-.384 0-.245.134-.385.135-.14.37-.14.076 0 .148.015.073.016.14.047z"></path>
          <path d="M7.696 2.679q-.2 0-.277.045-.077.046-.077.156 0 .088.057.14.059.05.158.05.137 0 .22-.096.082-.098.082-.259V2.68zm.328-.068v.571h-.165V3.03q-.056.092-.14.135-.084.043-.206.043-.154 0-.245-.085-.09-.087-.09-.232 0-.17.112-.255.114-.086.338-.086h.231v-.016q0-.114-.075-.176-.074-.062-.21-.062-.085 0-.167.02-.08.021-.156.062v-.152q.09-.035.175-.052.085-.018.166-.018.217 0 .325.113.107.113.107.342z"></path>
          <path d="M9.002 2.21v.156q-.07-.036-.145-.054-.075-.018-.156-.018-.122 0-.184.038-.06.037-.06.112 0 .058.043.09.044.033.176.062l.057.013q.175.038.248.106.075.068.075.191 0 .14-.111.221-.11.081-.304.081-.08 0-.168-.016-.087-.015-.183-.046v-.17q.09.047.18.071.088.024.175.024.116 0 .179-.04.062-.04.062-.112 0-.068-.045-.103-.045-.036-.198-.07l-.057-.013q-.153-.032-.221-.098-.068-.067-.068-.184 0-.14.1-.218.1-.077.285-.077.09 0 .171.014.08.013.149.04z"></path>
          <path d="M9.48 1.896v.284h.34v.128h-.34v.544q0 .123.034.158t.137.035h.169v.137h-.17q-.19 0-.263-.07-.072-.072-.072-.26v-.544h-.12V2.18h.12v-.284z"></path>
          <path d="M11.26 2.556q.057.02.112.084.055.065.11.177l.184.365h-.194l-.17-.342q-.067-.134-.13-.178-.061-.044-.169-.044h-.196v.564h-.181V1.847h.408q.229 0 .342.095.112.096.112.29 0 .126-.059.209-.058.083-.17.115zm-.453-.56v.473h.227q.13 0 .197-.06t.067-.178q0-.117-.067-.176-.067-.06-.197-.06z"></path>
          <path d="M12.7 1.89v.177q-.103-.05-.194-.074-.092-.024-.177-.024-.147 0-.228.058-.08.057-.08.162 0 .089.053.135.054.044.203.072l.109.022q.202.039.298.136.096.097.096.26 0 .194-.13.294-.13.1-.382.1-.094 0-.202-.021-.106-.022-.22-.064v-.186q.11.062.215.093.105.032.207.032.155 0 .24-.061.083-.061.083-.174 0-.098-.06-.154-.06-.055-.198-.083l-.11-.021q-.202-.04-.293-.126-.09-.086-.09-.24 0-.176.124-.278.126-.102.345-.102.094 0 .191.017.098.017.2.05z"></path>
          <path d="M13.863 1.89v.177q-.103-.05-.194-.074-.092-.024-.177-.024-.147 0-.228.058-.08.057-.08.162 0 .089.053.135.054.044.203.072l.109.022q.202.039.298.136.096.097.096.26 0 .194-.13.294-.13.1-.381.1-.095 0-.203-.021-.106-.022-.22-.064v-.186q.11.062.215.093.106.032.208.032.154 0 .238-.061.085-.061.085-.174 0-.098-.061-.154-.06-.055-.198-.083l-.11-.021q-.202-.04-.293-.126-.09-.086-.09-.24 0-.176.124-.278.126-.102.345-.102.094 0 .191.017.098.017.2.05z"></path>
          <path d="M14.808 1.847h.767v.152h-.587v.393h.53v.153h-.53v.637h-.18z"></path>
          <path d="M16.611 2.64v.08h-.757q.011.17.102.26.093.089.256.089.095 0 .184-.023.09-.024.177-.07v.155q-.089.038-.182.058-.093.02-.188.02-.24 0-.38-.14t-.14-.378q0-.246.132-.39.133-.145.359-.145.202 0 .32.13.117.13.117.354zm-.164-.048q-.002-.135-.076-.216-.074-.08-.195-.08-.138 0-.221.078-.083.077-.095.219z"></path>
          <path d="M17.739 2.64v.08h-.757q.01.17.102.26.092.089.256.089.095 0 .183-.023.09-.024.177-.07v.155q-.088.038-.181.058-.093.02-.19.02-.239 0-.38-.14-.139-.14-.139-.378 0-.246.132-.39.134-.145.36-.145.201 0 .319.13t.118.354zm-.165-.048q-.002-.135-.076-.216-.073-.08-.195-.08-.138 0-.22.078-.083.077-.096.219z"></path>
          <path d="M18.668 2.332V1.79h.165v1.392h-.165v-.15q-.052.09-.131.133-.079.043-.19.043-.181 0-.296-.145-.114-.144-.114-.38 0-.237.114-.382.115-.145.296-.145.111 0 .19.044.08.043.131.132zm-.56.35q0 .182.074.286.075.103.205.103.131 0 .206-.103.075-.104.075-.286 0-.181-.075-.284-.075-.104-.206-.104-.13 0-.205.104-.075.103-.075.284z"></path>
        </g>
        <path
          d="M15.527 15.31v.3q-.144-.134-.308-.2-.163-.067-.347-.067-.363 0-.555.222-.193.221-.193.64 0 .418.193.64.192.22.555.22.184 0 .347-.066.164-.066.308-.2v.298q-.15.102-.318.153-.167.05-.354.05-.48 0-.756-.292-.276-.295-.276-.803 0-.51.276-.802.276-.295.756-.295.19 0 .357.051.168.05.315.15z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M16.572 15.857q-.21 0-.331.164-.122.163-.122.447 0 .285.12.45.122.162.333.162.208 0 .33-.164.121-.164.121-.448 0-.281-.121-.445-.122-.166-.33-.166zm0-.22q.34 0 .533.22.194.22.194.611 0 .39-.194.612-.194.22-.533.22-.341 0-.535-.22-.193-.222-.193-.612t.193-.611q.194-.22.535-.22z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M17.983 17.022v.84h-.262v-2.188h.262v.241q.082-.142.207-.21.126-.069.3-.069.288 0 .468.23.181.229.181.602 0 .374-.18.603-.18.23-.47.23-.173 0-.3-.068-.124-.07-.206-.211zm.886-.554q0-.287-.119-.45-.117-.164-.324-.164-.207 0-.326.164-.117.163-.117.45 0 .288.117.452.12.163.326.163.207 0 .324-.163.119-.164.119-.452z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M20.23 17.407q-.11.283-.215.37-.104.086-.28.086h-.208v-.218h.153q.108 0 .167-.051.06-.051.132-.24l.046-.12-.64-1.56h.275l.496 1.24.495-1.24h.276z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M22.868 17.407q-.11.283-.216.37-.104.086-.28.086h-.208v-.218h.153q.108 0 .167-.051.06-.051.132-.24l.046-.12-.64-1.56h.275l.496 1.24.495-1.24h.276z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M24.538 15.857q-.21 0-.331.164-.122.163-.122.447 0 .285.12.45.122.162.333.162.208 0 .33-.164.121-.164.121-.448 0-.281-.121-.445-.122-.166-.33-.166zm0-.22q.34 0 .533.22.194.22.194.611 0 .39-.194.612-.194.22-.533.22-.341 0-.535-.22-.193-.222-.193-.612t.193-.611q.194-.22.535-.22z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M25.67 16.634v-.96h.26v.95q0 .225.088.338.088.112.264.112.21 0 .332-.134.123-.135.123-.367v-.899h.26v1.586h-.26v-.244q-.094.145-.22.215-.125.07-.29.07-.274 0-.415-.17-.142-.17-.142-.497zm.655-.998z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M28.453 15.918q-.044-.026-.096-.037-.051-.013-.114-.013-.22 0-.34.145-.117.143-.117.412v.835h-.262v-1.586h.262v.247q.082-.145.214-.214.132-.07.32-.07.027 0 .06.003.032.003.071.01z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M14.947 19.892q.092.031.178.133.088.102.176.28l.29.578h-.307l-.27-.542q-.105-.212-.204-.282-.098-.069-.268-.069h-.311v.893h-.286V18.77h.645q.363 0 .54.151.18.152.18.458 0 .2-.094.33-.092.132-.27.183zm-.716-.887v.75h.36q.206 0 .31-.095.107-.096.107-.281 0-.186-.106-.28-.105-.094-.312-.094z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M17.226 18.84v.278q-.163-.078-.307-.116-.145-.038-.28-.038-.233 0-.36.09-.126.091-.126.258 0 .14.083.212.085.071.32.115l.173.035q.32.061.471.216.153.152.153.41 0 .307-.207.466-.205.158-.603.158-.15 0-.32-.034-.168-.034-.349-.1v-.295q.174.098.341.148.167.05.328.05.245 0 .378-.097.133-.096.133-.275 0-.155-.096-.243-.095-.088-.313-.132l-.174-.034q-.32-.064-.463-.2-.143-.135-.143-.377 0-.28.197-.442.198-.161.545-.161.149 0 .303.027.154.026.316.08z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M19.066 18.84v.278q-.163-.078-.307-.116-.145-.038-.28-.038-.233 0-.36.09-.126.091-.126.258 0 .14.083.212.085.071.32.115l.173.035q.32.061.471.216.153.152.153.41 0 .307-.207.466-.205.158-.603.158-.15 0-.32-.034-.168-.034-.349-.1v-.295q.174.098.341.148.167.05.328.05.245 0 .378-.097.133-.096.133-.275 0-.155-.096-.243-.095-.088-.313-.132l-.174-.034q-.32-.064-.463-.2-.142-.135-.142-.377 0-.28.196-.442.198-.161.545-.161.149 0 .303.027.154.026.316.08z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M21.352 18.68v.217h-.25q-.14 0-.195.057-.054.057-.054.204v.14h.43v.202h-.43v1.383h-.261V19.5h-.25v-.202h.25v-.11q0-.265.123-.386t.39-.121z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M22.926 20.025v.128h-1.198q.017.269.162.41.145.14.404.14.15 0 .29-.036.142-.037.28-.11v.245q-.14.06-.287.091-.147.031-.298.031-.38 0-.602-.22-.22-.221-.22-.598 0-.39.209-.617.21-.23.567-.23.32 0 .506.207.187.206.187.56zm-.26-.076q-.004-.214-.121-.341-.116-.128-.309-.128-.218 0-.35.124-.13.123-.15.346z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M24.709 20.025v.128h-1.197q.017.269.16.41.147.14.406.14.15 0 .29-.036.141-.037.28-.11v.245q-.14.06-.287.091-.147.031-.299.031-.38 0-.601-.22-.221-.221-.221-.598 0-.39.21-.617.21-.23.567-.23.32 0 .505.207.187.206.187.56zm-.26-.076q-.003-.214-.12-.341-.117-.128-.31-.128-.217 0-.349.124-.13.123-.15.346z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
        <path
          d="M26.18 19.538v-.857h.26v2.202h-.26v-.238q-.082.142-.208.211-.125.068-.3.068-.288 0-.469-.23-.18-.228-.18-.602t.18-.603q.181-.23.469-.23.175 0 .3.07.126.068.208.21zm-.888.554q0 .287.118.451.119.163.325.163.207 0 .326-.163.119-.164.119-.451 0-.287-.12-.45-.118-.164-.325-.164-.206 0-.325.164-.118.163-.118.45z"
          style={{ lineHeight: "1.25" }}
          strokeWidth="0.181"
          fontSize="2.899"
        ></path>
      </g>
    </svg>
  );
}

export default PodcastIntroStep1;
